/*
 * @Author: your name
 * @Date: 2020-07-30 15:32:11
 * @LastEditTime: 2020-08-03 16:43:16
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-text-input.config.js
 */
const FormTextInputConfig = {
  // 类型
  componentType: 'FORM_TEXT_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-text',
    text: '单行输入',
    optionTitle: true,
    description: '用于输入普通文本，最大长度限制200字符'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormTextInput',
      edit: 'FormTextInput',
      read: 'FormTextInput'
    },
    lengthLimit: 200,
    label: '单行输入',
    placeholder: '请输入',
    enableRule: false,
    inTable: true,
    methods: {
      lcInitData: {
        edit: (...args) => {
        }
      },
      lcFormatValue: (value, config) => {
        let realResult = null
        try {
          if (value !== undefined && value !== null) {
            realResult = value.toString().substring(0, config.lengthLimit)
          }
        } catch (error) {
          realResult = null
        }
        return realResult
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'MAXLENGTH',
    'INPUT_DEFAULT',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormTextInputConfig
